var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8599 5.86392C10.6731 6.04536 10.3703 6.04536 10.1836 5.86392L5.5 1.3141L0.816442 5.86392C0.629669 6.04536 0.326852 6.04536 0.140079 5.86392C-0.0466938 5.68248 -0.0466938 5.38831 0.140079 5.20687L5.5 0L10.8599 5.20687C11.0467 5.38831 11.0467 5.68248 10.8599 5.86392Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/dropDown.28c8ec1ddff3a3f6d984d4f3268d1d01.svg";
export { ForwardRef as ReactComponent };